export default __webpack_public_path__ + "static/icelandairlogo-a06c5eeeba86e777c7be3f9051ef12d4.jpg";